import request from '../utils/request'

export function ownerPage(params) {
  return request({
    url: '/owner/page',
    method: 'GET',
    params: params
  })
}

export function ownerDel(params) {
  return request({
    url: '/owner/deleted/' + params.id,
    method: 'DELETE'
  })
}

export function addressPage(params) {
  return request({
    url: '/address/page',
    method: 'GET',
    params: params
  })
}

export function addressCreate(data) {
  return request({
    url: '/address/create',
    method: 'POST',
    data
  })
}

export function addressDetail(params) {
  return request({
    url: '/address/' + params.id,
    method: 'GET'
  })
}


export function createOrUpdateCopyrightOwner(data) {
  return request({
    url: '/copyright/createOrUpdateCopyrightOwner',
    method: 'POST',
    data
  })
}

// export function ownerStartDate(params) {
//   return request({
//     url: '/owner/start/date',
//     method: 'GET',
//     params
//   })
// }

export function ownerStartMinDate(data) {
  return request({
    url: '/owner/start/minDate',
    method: 'POST',
    data
  })
}

export function ownerSetProxy(params) {
  return request({
    url: '/owner/setProxy',
    method: 'PUT',
    params
  })
}
